import type { MemoryCard } from './types';

const SYMBOLS = ['berry', 'flower', 'crystal', 'shell'];

type Rng = () => number;

export function createBoard(rng: Rng = Math.random): MemoryCard[] {
  const pairs = [...SYMBOLS, ...SYMBOLS];
  for (let i = pairs.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [pairs[i], pairs[j]] = [pairs[j]!, pairs[i]!];
  }
  return pairs.map((symbol, id) => ({ id, symbol, revealed: false, matched: false }));
}

export function flipCard(board: MemoryCard[], id: number): MemoryCard[] {
  return board.map((c) => (c.id === id && !c.matched ? { ...c, revealed: true } : c));
}

export function checkMatch(board: MemoryCard[]): { board: MemoryCard[]; matched: boolean } {
  const flipped = board.filter((c) => c.revealed && !c.matched);
  if (flipped.length !== 2) return { board, matched: false };
  const [a, b] = flipped as [MemoryCard, MemoryCard];
  if (a.symbol === b.symbol) {
    return {
      board: board.map((c) => (c.id === a.id || c.id === b.id ? { ...c, matched: true } : c)),
      matched: true,
    };
  }
  return {
    board: board.map((c) =>
      c.id === a.id || c.id === b.id ? { ...c, revealed: false } : c,
    ),
    matched: false,
  };
}

export function isComplete(board: MemoryCard[]): boolean {
  return board.every((c) => c.matched);
}

export function memoryReward(): number {
  return 15;
}
